<template>
    <div class="com-course-record-item" @click="clickItem">
        <div class="com-course-record-item-img">
            <img class="com-course-record-item-img-img" v-lazy="itemData && itemData.info ? itemData.info.f_pic : ''" alt="">
        </div>
        <div class="com-course-record-content">
            <div class="com-course-record-item-title">{{ itemData && itemData.info ? itemData.info.f_title : '' }}</div>
            <div class="com-course-record-item-info">
                <span>用时 {{ itemData && itemData.studyTimeStr ? itemData.studyTimeStr : '' }}</span>
            </div>
            <div class="com-course-record-item-progress">
                <van-progress track-color="#EBEBEB" color="#FF4406" :percentage="itemData && itemData.f_percentage ? itemData.f_percentage : 0" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CourseRecordItem',
    props: {
        itemData: {
            type: Object,
            default() { return {} }
        }
    },
    data() {
        return {
            locked: false
        }
    },
    methods:{
        clickItem() {
            if(this.locked) { return; }
            this.locked = true;
            setTimeout(() => {
                this.locked = false;
            }, 1000);
            let userVip = this.$store.state.userData.vip;
            console.log(this.itemData, userVip);
            
            this.$store.dispatch('course/getCourseDetailInfo', {
                dId: this.itemData.f_catalog_id,
                sucCb: () => {
                    this.$router.replace('/course/courserecord/'+this.itemData.f_catalog_id);
                    this.$store.dispatch('course/getCourseTableList', {
                        cid: this.itemData.f_course_id,
                        vip: userVip
                    });
                }
            });
        }
    }
}
</script>
